import { get } from 'lodash'

export default function(data) {
  return {
    stateOrProvinceOrRegion: get(data, 'stateOrProvinceOrRegion'),
    organizationId: get(data, 'organizationId') || get(data, 'organization.id'),
    nationality: get(data, 'nationality'),
    phoneNumber: get(data, 'phoneNumber'),
    middleName: get(data, 'middleName'),
    phoneType: get(data, 'phoneType'),
    firstName: get(data, 'firstName'),
    countryId: get(data, 'countryId'),
    birthDate: get(data, 'birthDate'),
    lastName: get(data, 'lastName'),
    emailAgain: get(data, 'email'),
    zipCode: get(data, 'zipCode'),
    gender: get(data, 'gender'),
    email: get(data, 'email'),
    line1: get(data, 'line1'),
    line2: get(data, 'line2'),
    title: get(data, 'title'),
    city: get(data, 'city')
  }
}
